var _REDUX_DEVTOOLS_EXTE;
import { applyMiddleware, createStore, compose, combineReducers } from 'redux';
import rootMiddleware from "./middleware/index.js";
import reducers from "./reducers/index.js";
import reducerRegistry from "./reducerRegistry.js";
Object.entries(reducers).map(_ref => {
  var [name, reducer] = _ref;
  return reducerRegistry.register(name, reducer);
});
var composeEnhancers = // eslint-disable-next-line @typescript-eslint/no-explicit-any
(_REDUX_DEVTOOLS_EXTE = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) !== null && _REDUX_DEVTOOLS_EXTE !== void 0 ? _REDUX_DEVTOOLS_EXTE : compose;
var store = createStore(combineReducers(reducerRegistry.reducers), composeEnhancers(applyMiddleware(...rootMiddleware)));
reducerRegistry.setListener(newReducers => {
  store.replaceReducer(combineReducers(newReducers));
});
export default store;
//# sourceMappingURL=store.js.map